// The /changelog page's title and share image, kept apart from the entries so the
// main app bundle does not carry them.
import { PAGE_IMAGES } from './pageImages';

export const CHANGELOG_META = {
  title: "What's New on Zuzu | Latest Updates | Zuzu Club",
  description: 'The latest changes to Zuzu Club, in plain words: new chat features, new pages, and safety and privacy updates.',
  image: PAGE_IMAGES['/changelog'].image,
  alt: PAGE_IMAGES['/changelog'].alt,
};
